export const ImageKeywords = [
  "Abstract",
  "Mind",
  "Creative",
  "Creativity",
  "Wisdom",
  "Innovation",
  "Human",
  "People",
  "Communication",
  "Psychology",
  "Wellness",
  "Fitness",
  "Technology",
  "Code",
  "Science",
  "Space",
  "Nature",
  "Animals",
  "Finance",
  "Business",
  "City",
  "Culture",
  "Art",
  "Travel",
  "Productivity",
  "Health",
  "Food",
  "Moods",
  "Macro",
  "Underwater",
  "Objects",
  "Sea",
  "Mountains",
  "Forest",
  "Ocean",
  "Texture",
  "Music",
  "Architecture",
] as const;

export type ImageKeyword = (typeof ImageKeywords)[number];

/** The image an article, keypoint or author carries. */
export type Image = {
  id: string;
  alt: string;
  src: string;
  attributionHtml: string;
};

export type ImageStock = {
  id: string;
  alt: string;
  src: string;
  collectionId: string;
  keyword: ImageKeyword;
  user: string;
  userProfile: string;
  downloadLocation: string;
  authorAlias?: string;
  articleId?: string;
  keypointIndex?: number;
  createdAt: number;
  updatedAt: number;
  used: "yes" | "no";
};

export type ImageStockCollection = {
  id: string;
  title: string;
  keyword: ImageKeyword;
  totalImages: number;
  imagesCrawled: number;
  status: "active" | "completed" | "cancelled";
  lastCrawledPage: number;
  createdAt: number;
  updatedAt: number;
};
